import api from "../utils/api"; // Your configured Axios instance

// Function to get address types
export const getAddressType = async () => {
  try {
    const response = await api.get("/api/values/address-type");
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to get address types"
    );
  }
};

// Function to get branch types
export const getBranchType = async () => {
  try {
    const response = await api.get("/api/values/branch-type");
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to get branch types"
    );
  }
};

// Function to get client types (you already have this)
export const getClientType = async () => {
  try {
    const response = await api.get("/api/values/client-type");
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to get client types"
    );
  }
};

// Function to get contact types
export const getContactType = async () => {
  try {
    const response = await api.get("/api/values/contact-type");
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to get contact types"
    );
  }
};

// Function to get genders
export const getGender = async () => {
  try {
    const response = await api.get("/api/values/gender");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to get genders");
  }
};

// Function to get offering types
export const getOfferingType = async () => {
  try {
    const response = await api.get("/api/values/offering-type");
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to get offering types"
    );
  }
};

// Function to get registration statuses
export const getRegistrationStatus = async () => {
  try {
    const response = await api.get("/api/values/registration-status");
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to get registration statuses"
    );
  }
};

// Function to get venture types
export const getVentureType = async () => {
  try {
    const response = await api.get("/api/values/venture-type");
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to get venture types"
    );
  }
};

// Function to get user roles
export const getUserRole = async () => {
  try {
    const response = await api.get("/api/values/user-role");
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to get user roles"
    );
  }
};

// Function to get form statuses
export const getFormStatus = async () => {
  try {
    const response = await api.get("/api/values/form-status");
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to get form statuses"
    );
  }
};
